import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Folder, BookOpen, Users, BarChart, ArrowUpRight } from "lucide-react";
import { Link } from "wouter";
import { cn } from "@/lib/utils";
import { SectionHelp } from "@/components/help";

const links = [
  { 
    icon: <Folder className="h-5 w-5" />, 
    label: "Projects", 
    href: "/projects"
  },
  { 
    icon: <BookOpen className="h-5 w-5" />, 
    label: "Knowledge", 
    href: "/knowledge"
  },
  { 
    icon: <BarChart className="h-5 w-5" />, 
    label: "Surveys", 
    href: "/surveys"
  },
  { 
    icon: <Users className="h-5 w-5" />, 
    label: "Directory", 
    href: "/directory"
  }
];

export default function QuickLinks() {
  return (
    <Card className="h-full border border-border shadow-sm">
      <CardHeader className="pb-4 border-b border-border">
        <SectionHelp contentId="dashboard:quick-links" tooltip="Learn about Quick Links">
          <CardTitle className="text-lg font-bold text-foreground">Quick Links</CardTitle>
        </SectionHelp>
      </CardHeader>
      
      <CardContent className="p-4">
        <div className="grid grid-cols-2 gap-3">
          {links.map((link, index) => (
            <Link 
              key={index} 
              href={link.href}
              className={cn(
                "group relative flex flex-col items-center justify-center p-4 rounded-lg",
                "bg-card border border-border",
                "hover:shadow-sm hover:border-border transition-all duration-200"
              )}
            >
              <div className={cn(
                "flex items-center justify-center w-10 h-10 rounded-lg mb-2 bg-muted text-foreground",
                "group-hover:bg-accent transition-colors duration-200"
              )}>
                {link.icon}
              </div>
              <span className="text-sm font-semibold text-foreground group-hover:text-foreground">
                {link.label}
              </span>
              <ArrowUpRight className="absolute top-2 right-2 h-3 w-3 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
